import { tss } from "tss-react/mui";

export const useProductDetailSectionStyles = tss.withName("ProductDetailSection").create(({ theme }) => ({
    root: {
        padding: "48px 4% 80px",
    },
    container: {
        maxWidth: "1640px",
        margin: "0 auto",
    },
    breadcrumb: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(3),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        fontSize: "0.85rem",
    },
    breadcrumbLink: {
        color: theme.palette.text.secondary,
        textDecoration: "none",
        "&:hover": { color: theme.palette.primary.main },
    },
    layout: {
        display: "grid",
        gridTemplateColumns: "1.15fr 1fr",
        gap: theme.spacing(9),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            gap: theme.spacing(4),
        },
    },
    mainImageWrapper: {
        width: "100%",
        aspectRatio: "1 / 1",
        overflow: "hidden",
        backgroundColor: theme.palette.primary[50],
        marginBottom: theme.spacing(1.5),
    },
    mainImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
    },
    thumbRow: {
        display: "flex",
        gap: theme.spacing(1.5),
    },
    thumb: {
        width: 80,
        height: 80,
        overflow: "hidden",
        cursor: "pointer",
        border: "1px solid transparent",
        opacity: 0.6,
        transition: "opacity 0.2s ease, border-color 0.2s ease",
    },
    thumbActive: {
        opacity: 1,
        borderColor: theme.palette.text.primary,
    },
    thumbImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
    },
    vendor: {
        fontSize: "0.7rem",
        color: theme.palette.text.secondary,
        textTransform: "uppercase" as const,
        letterSpacing: "0.08em",
        fontWeight: 600,
        marginBottom: theme.spacing(1.5),
    },
    title: {
        marginBottom: theme.spacing(2.5),
    },
    priceRow: {
        display: "flex",
        alignItems: "baseline",
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
    },
    price: {
        fontFamily: "'Fira Code', monospace",
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    compareAtPrice: {
        fontFamily: "'Fira Code', monospace",
        color: theme.palette.text.disabled,
        textDecoration: "line-through",
    },
    availability: {
        marginBottom: theme.spacing(3),
        fontSize: "0.85rem",
        fontWeight: 500,
    },
    inStock: {
        color: theme.palette.success.main,
    },
    outOfStock: {
        color: theme.palette.error.main,
    },
    optionGroup: {
        marginBottom: theme.spacing(3),
    },
    optionLabel: {
        fontWeight: 600,
        fontSize: "0.8rem",
        textTransform: "uppercase" as const,
        letterSpacing: "0.04em",
        marginBottom: theme.spacing(1),
    },
    optionChips: {
        display: "flex",
        flexWrap: "wrap" as const,
        gap: theme.spacing(1),
    },
    quantityRow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    quantityControl: {
        display: "flex",
        alignItems: "center",
        border: `1px solid ${theme.palette.divider}`,
    },
    quantityButton: {
        minWidth: 36,
        borderRadius: 0,
    },
    quantityValue: {
        minWidth: 32,
        textAlign: "center" as const,
        fontFamily: "'Fira Code', monospace",
        fontWeight: 500,
    },
    addToCartRow: {
        display: "flex",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(5),
        flexWrap: "wrap" as const,
    },
    descriptionTitle: {
        fontWeight: 600,
        fontSize: "0.8rem",
        textTransform: "uppercase" as const,
        letterSpacing: "0.06em",
        marginBottom: theme.spacing(1.5),
    },
    description: {
        color: theme.palette.text.secondary,
        lineHeight: 1.8,
        marginBottom: theme.spacing(4),
        "& p": { marginBottom: theme.spacing(1.5) },
        "& ul": { paddingLeft: theme.spacing(3) },
        "& li": { marginBottom: theme.spacing(0.5) },
    },
    specsRow: {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: theme.spacing(3),
        padding: theme.spacing(3, 0),
        borderTop: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(1),
    },
    specLabel: {
        fontFamily: "'Fira Code', monospace",
        fontSize: "0.7rem",
        textTransform: "uppercase" as const,
        letterSpacing: "0.06em",
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
    },
    specValue: {
        fontSize: "0.9rem",
        color: theme.palette.text.primary,
    },
    shippingBox: {
        padding: theme.spacing(3, 0),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    shippingText: {
        color: theme.palette.text.secondary,
        lineHeight: 1.8,
        fontSize: "0.9rem",
    },
}));
